<div class="usa-form">
  <div class="select-wrapper">
    <label id="globalSearchSelectLabel" class="usa-sr-only" [for]="'searchType-' + elementId"
      >Select Search Type</label
    >
    <select
      class="usa-select"
      name="searchOptions"
      [id]="'searchType-' + elementId"
      [(ngModel)]="selectedSearchOption"
      [attr.aria-required]="true"
      [attr.aria-describedby]="'searchExplanation'"
    >
      @for (searchOption of searchOptions; track searchOption) {
        <option [ngValue]="searchOption">
          {{ searchOption }}
        </option>
      }
    </select>
  </div>
  <div class="select-input">
    <label id="globalSearchLabel" class="usa-sr-only" [for]="'global-search-input-' + elementId"
      >Global Search</label
    >
    <input
      #nameSearch
      type="text"
      class="usa-input"
      [id]="'global-search-input-' + elementId"
      [(ngModel)]="searchText"
      (keyup)="onkeyup($event)"
      [attr.aria-required]="true"
      [attr.aria-describedby]="'searchExplanation'"
    />
  </div>

  <p id="searchExplanation" class="usa-sr-only">
    Choose the search type above and then enter your search query here.
  </p>

  <div class="button-wrapper">
    <button class="usa-button" (click)="performSearch()">Search</button>
  </div>
</div>
@if (showError) {
  <div
    role="alert"
    aria-invalid="true"
    [attr.aria-describedby]="'global-search-input-' + elementId"
    class="form-control-feedback"
    tabindex="0"
  >
    Please enter valid search text.
  </div>
}
